export default "__VITE_ASSET__UQoyBaQH__"